import client from 'src/services/api/client';
import { getApiUrl, LOGIN_PAGE } from 'src/config';

export function clearLocalSession() {
  localStorage.removeItem('auth');
  localStorage.removeItem('user');
  localStorage.removeItem('activeCompanyId');
  localStorage.removeItem('companies');
  sessionStorage.removeItem('keycloak_pending_code');
  sessionStorage.removeItem('keycloak_exchanged_code');
  if (client.defaults?.headers?.common) {
    delete client.defaults.headers.common.Authorization;
  }
}

export function redirectToKeycloakLogout(redirectPath = LOGIN_PAGE) {
  const postLogoutRedirectUri = redirectPath.startsWith('http')
    ? redirectPath
    : `${window.location.origin}${redirectPath}`;
  const url = `${getApiUrl('Oauth/keycloak/logout')}?postLogoutRedirectUri=${encodeURIComponent(
    postLogoutRedirectUri
  )}`;
  window.location.replace(url);
}

export function keycloakLogout(redirectPath = LOGIN_PAGE) {
  clearLocalSession();
  redirectToKeycloakLogout(redirectPath);
}
